import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { SabisArrowIconComponent } from '../sabis-icons/arrow-icon.component';

@Component({
  selector: 'sabis-ngx-accordion',
  templateUrl: './sabis-accordion.component.html',
  styleUrls: ['./sabis-accordion.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        animate(200, style({ opacity: 0, height: 0 }))
      ])
    ])
  ],
  imports: [
    CommonModule,
    SabisArrowIconComponent
  ]
})
export class SabisNgxAccordionComponent {
  @Input() scIsCollapsed = true;
  @Input() scTitle: string = '';
  @ContentChild(TemplateRef, { static: true }) templateRef!: TemplateRef<any>;
  @Output() open: EventEmitter<Event> = new EventEmitter<Event>();

  constructor() {
  }

  toggleViewMode() {
    this.scIsCollapsed = !this.scIsCollapsed;
    if (this.scIsCollapsed) {
      this.open.emit();
    }
  }
}
